module.exports = __webpack_public_path__ + "static/media/SOFT-DRINKS-MIXERS.805b205b.jpg";